import { render, staticRenderFns } from "./c-data-tab@.vue?vue&type=template&id=c50d9242&scoped=true&"
import script from "./c-data-tab@.vue?vue&type=script&lang=ts&"
export * from "./c-data-tab@.vue?vue&type=script&lang=ts&"
import style0 from "./c-data-tab@.vue?vue&type=style&index=0&id=c50d9242&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c50d9242",
  null
  
)

export default component.exports